export default __webpack_public_path__ + "static/media/36I-117129_-44087_0.c23bc0cd.jpg";